var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "title": "유통데이터 활용 경진대회 지원",
            "src": "/images/sub/sub-visual-circulation.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('div', {
    staticClass: "mb-20px"
  }, [_c('v-tabs', {
    staticClass: "v-tabs--btn",
    attrs: {
      "hide-slider": "",
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, _vm._l(_vm.statuses, function (item, index) {
    return _c('v-tab', {
      key: index,
      staticClass: "pr-4px min-w-auto",
      class: index == 0 ? 'pl-0' : 'pl-4px'
    }, [_c('v-btn', {
      staticClass: "min-w-md-120px",
      attrs: {
        "large": "",
        "outlined": "",
        "color": "secondary"
      },
      on: {
        "click": function click($event) {
          _vm.filter.status = item.value, _vm.search(true);
        }
      }
    }, [_c('span', {
      staticClass: "font-size-md-18"
    }, [_vm._v(_vm._s(item.name))])])], 1);
  }), 1)], 1), _c('v-divider', {
    staticClass: "grey darken-4 mb-20px mb-md-32px",
    staticStyle: {
      "border-width": "2px 0 0"
    }
  }), _c('v-row', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_vm._l(_vm.applications, function (application, index) {
    return [_c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "md": "4",
        "lg": "3"
      }
    }, [_c('image-board', {
      attrs: {
        "tile": "",
        "flat": ""
      },
      on: {
        "click": function click($event) {
          return _vm.$router.push("/circulation/support/" + application._id);
        }
      },
      scopedSlots: _vm._u([{
        key: "image",
        fn: function fn() {
          return [application.thumb ? _c('v-img', {
            staticClass: "grey lighten-5",
            attrs: {
              "cover": "",
              "width": "100%",
              "aspect-ratio": 282 / 370,
              "src": application.thumb.src
            }
          }, [_c('v-overlay', {
            staticClass: "pt-10px pl-10px justify-start align-start",
            attrs: {
              "absolute": "",
              "opacity": "0"
            }
          }, [application.status == '모집중' ? _c('v-chip', {
            staticClass: "w-md-100px",
            attrs: {
              "large": "",
              "color": "white"
            }
          }, [_c('span', {
            staticClass: "font-weight-medium secondary--text"
          }, [_vm._v("모집중")])]) : _vm._e(), application.status == '모집 종료' ? _c('v-chip', {
            staticClass: "w-md-100px",
            attrs: {
              "large": "",
              "color": "white"
            }
          }, [_c('span', {
            staticClass: "font-weight-medium secondary--text"
          }, [_vm._v("모집 종료")])]) : _vm._e()], 1)], 1) : _vm._e()];
        },
        proxy: true
      }, {
        key: "subject",
        fn: function fn() {
          return [_vm._v(" " + _vm._s(application.subject) + " ")];
        },
        proxy: true
      }], null, true)
    }, [[_c('v-row', {
      staticClass: "row--xs"
    }, [_vm._l(application.items, function (item, index) {
      return [item.title == '모집 기간' ? _c('v-col', {
        key: index,
        attrs: {
          "cols": "12"
        }
      }, [_c('div', {
        staticClass: "font-size-16 grey--text text--lighten-1",
        domProps: {
          "innerHTML": _vm._s(item.txt.replace(/\n/g, '<br/>'))
        }
      })]) : _vm._e()];
    })], 2)]], 2)], 1)];
  })], 2), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }